<p-dialog header="Bid Instruction Change Log" #tt
    [modal]="true"
    [responsive]="true"
    [(visible)]="showDialog" 
    (onHide)="dialogHide()"
    [contentStyle]="{'width':'1200px','min-height':'320px','max-height':'650px','overflow-y':'auto'}">
    <form name="changeLogForm" [formGroup]="changeLogForm" (ngSubmit) = "onSubmitChangeLogForm()">
      <div style="display: flex;">
          <div class="formFields">
            <p-listbox #listboxChangedBy [options]="changedBy" 
                      [(ngModel)]="selectedChangedByUsers" 
                      multiple="multiple"  
                      optionLabel="name"
                      [filter]="showChangedbyFilter"
                      formControlName="changedBy" 
                      [checkbox]="showChangeByCheckBox"
                      [disabled]="disableChangeLogCheckBox"
                      styleClass="changeLogList">
              <p-header class="p-list-header">
                Changed By
              </p-header>
            </p-listbox>
        </div>
        <div  class="formFields">
            <p-listbox #listboxStates [options]="states" 
                    [(ngModel)]="selectedStates" 
                    multiple="multiple"  
                    optionLabel="name"
                    [checkbox]="showStateCheckBox"
                    [disabled]="disableStateCheckBox"
                    [filter]="showStatesFilter"
                    formControlName="states"
                    styleClass="changeLogList">
              <p-header class="p-list-header">
                Property States
              </p-header>
            </p-listbox> 
          </div>
          <div  class="formFields">  
            <p-listbox #listboxTrsustee [options]="trustee" 
                [(ngModel)]="selectedTrustee" 
                multiple="multiple" 
                [checkbox]="showTrusteeCheckBox"  
                optionLabel="name"
                [filter]="showTrusteeFilter"
                [disabled]="disableTrusteeCheckBox"
                formControlName="trustees"
                styleClass="changeLogList">
                <p-header class="p-list-header">
                  Trustee Name
                </p-header>
            </p-listbox>
          </div>
          <div style="width:40%">
            <div class="date-range-title">Date Range</div>
            <div style ="display: flex;">
              <p-calendar [(ngModel)]="minDate"  formControlName="fromDate" [showIcon]="true" class="form-group" 
                styleClass="treetableDate" >
              </p-calendar> <div class="calenderSpace">to</div>
              <p-calendar [(ngModel)]="maxDate" formControlName="toDate" [showIcon]="true" class="form-group" 
                styleClass="treetableDate"></p-calendar>
            </div>
            <div class="days-margin-left">
              <a class="underline" (click)="setDateRange(6)">last 7 days</a>&nbsp;
              <a class="underline" (click)="setDateRange(29)">Last 30 days</a>&nbsp;
              <a class="underline" (click)="setDateRange(89)">Last 90 days</a>
            </div>
          </div>
          <div class="form-group buttonStyles">
            <button pButton  type="submit" label="View" [disabled]="!changeLogForm.valid || disableChangeLogForm" class="margin-left-view-button"></button>&nbsp;&nbsp;
            <button pButton  type="button" label="Reset" (click)="resetForm()" class="ui-button-secondary margin-left"></button>
          </div>
        </div> 
    </form>

    <p-table #dt [value]="data"
        [columns]="cols"
        autoLayout=true 
        [rows]="10"
        [paginator]="isPaginatorVisible()"
        [totalRecords]="records" 
        [rowsPerPageOptions]="[10,25,50,100]"
        dataKey="BidMatrixAuditId" 
        rowExpandMode="multiple"
        [loading]="loading">

        <ng-template pTemplate="caption">
          <div style="margin-top: -16px; float: right; display: flex;" *ngIf="data && data.length >0"> 
              <div style="margin-top: 1.5%;font-size: 0.9em;">
                  {{records}} Records Found
              </div>&nbsp;&nbsp;  
          </div>
        </ng-template>

        <ng-template  pTemplate="header">
          <tr #header *ngIf="formSubmitted">
              <th style="width: 3em"></th>
              <ng-container *ngFor="let col of cols">
                  <th *ngIf="col.showInHeader">
                      {{col.header}}
                  </th>
              </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr *ngIf="!loading && data && data.length === 0 && formSubmitted">
              <td [attr.colspan]="10" class="center-align">No records found</td> 
          </tr>
        </ng-template>  

        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">
          <tr>
              <td>
                  <a href="#" [pRowToggler]="rowData" class="changeLogAnchor">
                      <i [ngClass]="expanded ? 'fas fa-minus-square' : 'fas fa-plus-square'"></i>
                  </a>
              </td>
              <ng-container *ngFor="let col of columns">
                  <td *ngIf="col.showInHeader">
                      {{rowData[col.field]}}
                  </td>
              </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-rowData  let-columns="columns" let-rowIndex="rowIndex">
          <tr>
              <td width="50%" colspan="2">
                <div class="section-header">Changed Values</div>
                <div class="section-data">
                    <span class="section-data-label">Bidding Instruction Document Included?: </span>&nbsp;
                    <span [ngClass]="(rowData.PreviousBidInstructionDocsIncluded !== null) ? 
                      (rowData.CurrentBidInstructionDocsIncluded != rowData.PreviousBidInstructionDocsIncluded ? 'section-data-value center-align':'section-data-value center-align removehighlight') : ''"> 
                      {{rowData.CurrentBidInstructionDocsIncluded == 1 ? 'Yes' : 'No'}}
                    </span>
                </div>
                <div class="section-data">
                  <span class="section-data-label">Certificate of Sale Altisource copy included?: </span>&nbsp;
                  <span [ngClass]="(rowData.PreviousCOSAltisourceCopyIncluded !== null) ? 
                    (rowData.CurrentCOSAltisourceCopyIncluded != rowData.PreviousCOSAltisourceCopyIncluded ? 'section-data-value center-align':'section-data-value center-align removehighlight') : ''"> 
                    {{rowData.CurrentCOSAltisourceCopyIncluded == 1 ? 'Yes' : 'No'}}
                  </span>
                </div>
                <div class="section-data" >
                  <span class="section-data-label">Certificate of Sale Buyer's copy included? </span>&nbsp;
                 <span [ngClass]="(rowData.PreviousCOSBuyerCopyIncluded !== null) ? 
                    (rowData.CurrentCOSBuyerCopyIncluded != rowData.PreviousCOSBuyerCopyIncluded ? 'section-data-value center-align':'section-data-value center-align removehighlight') : ''"> 
                  {{rowData.CurrentCOSBuyerCopyIncluded == 1 ? 'Yes' : 'No'}}
                </span>
                </div>
                <div class="section-data">
                  <span class="section-data-label">Altisource Bidding sheet included?: </span>&nbsp;
                  <span [ngClass]="(rowData.PreviousAltisourceBidSheetIncluded !== null) ? 
                    (rowData.CurrentAltisourceBidSheetIncluded != rowData.PreviousAltisourceBidSheetIncluded ? 'section-data-value center-align':'section-data-value center-align removehighlight') : ''"> 
                    {{rowData.CurrentAltisourceBidSheetIncluded == 1 ? 'Yes' : 'No'}}
                  </span>
                </div>
                <div class="section-data"  >
                  <span class="section-data-label">Bidding Instructions: </span>&nbsp;
                  <span class="section-data-value center-align" [ngClass]="rowData.PreviousBidInstructionFileId !=null ? (rowData.PreviousBidInstructionFileId != rowData.CurrentBidInstructionFileId ?
                    'section-data-value center-align' : '') :'' "> 
                    <a (click)="downloadBidInstructions(rowData.BidMatrixId)" >
                      {{rowData.StateCode}}_BidInstructions ({{rowData.CurrentFileUploadDate}})
                    </a>
                  </span>
                </div>
              </td>
              <td width="50%" colspan="3">  
                <div class="section-header">Previous Values</div>
                <div class="section-data">
                    <span class="section-data-label">Bidding Instruction Document Included?: </span>&nbsp;
                    <span [ngClass]="(rowData.PreviousBidInstructionDocsIncluded !== null) ? 
                      (rowData.CurrentBidInstructionDocsIncluded != rowData.PreviousBidInstructionDocsIncluded ? 'section-data-value center-align highlight':'section-data-value center-align removehighlight') : ''"> 
                      {{rowData.PreviousBidInstructionDocsIncluded == null ? '' : (rowData.PreviousBidInstructionDocsIncluded == 1 ? 'Yes':'No')}}
                    </span>
                </div>
                <div class="section-data" >
                  <span class="section-data-label">Certificate of Sale Altisource copy included?: </span>&nbsp;
                    <span [ngClass]="(rowData.PreviousCOSAltisourceCopyIncluded !== null) ? 
                      (rowData.CurrentCOSAltisourceCopyIncluded != rowData.PreviousCOSAltisourceCopyIncluded ? 'section-data-value center-align highlight':'section-data-value center-align removehighlight') : ''"> 
                      {{rowData.PreviousCOSAltisourceCopyIncluded == null ? '' : (rowData.PreviousCOSAltisourceCopyIncluded== 1 ? 'Yes' : 'No')}}
                    </span>
                </div>
                <div class="section-data">
                  <span class="section-data-label">Certificate of Sale Buyer's copy included?: </span>&nbsp;
                  <span [ngClass]="(rowData.PreviousCOSBuyerCopyIncluded !== null) ? 
                    (rowData.CurrentCOSBuyerCopyIncluded != rowData.PreviousCOSBuyerCopyIncluded ? 'section-data-value center-align highlight':'section-data-value center-align removehighlight') : ''"> 
                    {{rowData.PreviousCOSBuyerCopyIncluded == null ? '' : (rowData.PreviousCOSBuyerCopyIncluded == 1 ? 'Yes' : 'No')}}
                  </span>
                </div>
                <div class="section-data">
                  <span class="section-data-label">Altisource Bidding sheet included?: </span>&nbsp;
                  <span [ngClass]="(rowData.PreviousAltisourceBidSheetIncluded !== null) ? 
                    (rowData.CurrentAltisourceBidSheetIncluded != rowData.PreviousAltisourceBidSheetIncluded ? 'section-data-value center-align highlight':'section-data-value center-align removehighlight') : ''"> 
                    {{rowData.PreviousAltisourceBidSheetIncluded == null ? '' : (rowData.PreviousAltisourceBidSheetIncluded == 1? 'Yes': 'No')}}
                  </span>
                </div>
                <div class="section-data">
                  <span class="section-data-label">Bidding Instructions: </span>&nbsp;
                  <span class="section-data-value center-align" [ngClass]="rowData.PreviousBidInstructionFileId !=null ? (rowData.PreviousBidInstructionFileId != rowData.CurrentBidInstructionFileId ?
                    'section-data-value center-align highlight' : '') :'' "> 
                    <a (click)="downloadBidInstructions()" *ngIf="rowData.PreviousBidInstructionFileName && rowData.PreviousBidInstructionFileName.length >0">
                       {{rowData.StateCode}}_BidInstructions ({{rowData.PreviousFileUploadDate}})
                    </a>
                  </span>
                </div> 
              </td>
          </tr>
      </ng-template>

    </p-table>
</p-dialog>
